import { X } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import type { Supplier } from "@/types";

interface SelectedSuppliersChipsProps {
  selectedSupplierIds: Set<number>;
  allSuppliers: Supplier[];
  onRemoveSupplier: (supplierId: number) => void;
  onClearAll: () => void;
}

export default function SelectedSuppliersChips({
  selectedSupplierIds,
  allSuppliers,
  onRemoveSupplier,
  onClearAll,
}: SelectedSuppliersChipsProps) {
  if (selectedSupplierIds.size === 0) {
    return null;
  }

  const selectedSuppliers = allSuppliers.filter(supplier =>
    selectedSupplierIds.has(supplier.id)
  );

  return (
    <div className="border rounded-lg p-4 bg-muted/30">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-medium text-sm">
          Proveedores Seleccionados ({selectedSupplierIds.size})
        </h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onClearAll}
        >
          Deseleccionar todos
        </Button>
      </div>

      <div className="flex flex-wrap gap-2">
        {selectedSuppliers.map((supplier) => (
          <Badge
            key={supplier.id}
            variant="secondary"
            className="flex items-center gap-1 pr-1"
          >
            <span className="truncate max-w-48">
              {supplier.name}
            </span>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onRemoveSupplier(supplier.id)}
              className="h-4 w-4 p-0 hover:bg-destructive/10"
            >
              <X className="h-3 w-3" />
            </Button>
          </Badge>
        ))}
      </div>
    </div>
  );
}
